<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-button variant="primary" @click="saveSpreadsheetData" :disabled="isPresented || isLoading">
            <feather-icon icon="SaveIcon" class="mr-50" />
            <span class="align-middle">Guardar cambios</span>
          </b-button>
        </b-row>
      </b-card-body>
    </b-card>
    <div v-if="isLoading">
      <div class="text-center">
        <label>Cargando...</label>&nbsp;
        <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
      </div>
    </div>
    <div style="overflow: hidden;">
      <div id="excelWeb"></div>
    </div>
  </div>
</template>

<script>
import axiosIns from '../../libs/axios'
import Ripple from 'vue-ripple-directive'
import Handsontable from 'handsontable'
import 'handsontable/dist/handsontable.full.min.css'

import {
  BCard,
  BButton,
  BCardBody,
  VBModal,
  BRow,
  BSpinner,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BButton,
    BCardBody,
    BRow,
    BSpinner,
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
  data() {
    return {
      data: [],
      isPresented: true,
      isLoading: false,
    }
  },
  mounted() {
    this.getSpreadsheetData()
    this.checkIfPresented()
  },
  methods: {
    getUserID() {
      const textUserData = localStorage.getItem('userData')
      const jsonUserData = JSON.parse(textUserData)
      const { id } = jsonUserData
      return id
    },
    initHoT() {
      const container = document.querySelector('#excelWeb')
      new Handsontable(container, {
        data: this.data,
        colHeaders: this.colHeaders,
        columns: [
          { readOnly: true, type: 'text' },
          { readOnly: true, type: 'text' },
          { readOnly: true, type: 'text' },
          { readOnly: true, type: 'text' },
          { readOnly: true, type: 'text' },
          { readOnly: true, type: 'text' },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          { readOnly: false, type: 'numeric', allowInvalid: false, validator: this.integerValidator },
          {
            title: 'TOTAL',
            readOnly: true,
            // width: 100,
            type: {
              renderer: function (instance, td, row) {
                const cols = instance.countCols() - 1
                let total = 0
                const totalIndex = 6

                for (let index = (totalIndex); index < cols; index++) {
                  total += instance.getDataAtCell(row, index)
                }
                total = Math.round(total * 10000) / 10000
                total = total.toLocaleString('en-US')
                td.innerHTML = total;
                // td.style.fontWeight = 'bold';
                td.style.background = '#d7f1e1';
                td.style.textAlign = 'right';
              },
            },
          },
        ],
        rowHeaders: true,
        autoRowSize: true,
        height: '70vh',
        width: 'auto',
        dropdownMenu: true,
        contextMenu: true,
        manualColumnResize: false,
        manualColumnFreeze: true,
        allowRemoveColumn: false,
        allowInsertColumn: false,
        allowRemoveRow: false,
        allowInsertRow: false,
        filters: true,
        fixedColumnsLeft: 6,
        cells(row) {
          return {
            className: row % 2 === 0 ? 'even' : 'odd',
          };
        },
        licenseKey: 'non-commercial-and-evaluation',
      });
    },
    saveSpreadsheetData() {
      this.$swal({
        title: '¿Estas seguro?',
        text: 'Se guardarán los cambios realizados',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, guardar cambios',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          // Send data to server
          this.isLoading = true
          const URL = '/nomina/update_weeks'
          const config = {
            method: 'post',
            url: URL,
            data: {
              user_id: this.getUserID(),
              data: this.data,
              app_user_id: this.getUserID(),
            },
          }
          console.log(config)
          axiosIns(config)
            .then(response => {
              if (response && response.status === 200) {
                this.isLoading = false
                this.$swal({
                  icon: 'success',
                  title: '¡Guardado!',
                  text: 'La información de los puestos ha sido actualizada',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                }).then(x => this.$router.push({ name: 'request' }))
              } else {
                this.printErrorModal('Error en el servidor')
                this.isLoading = false
              }
            })
            .catch(error => {
              this.printErrorModal(error)
              this.isLoading = false
            })
        }
      })
    },
    getSpreadsheetData() {
      this.isLoading = true
      const URL = '/nomina/get_spreadsheet_data'
      const config = {
        method: 'get',
        url: URL,
        params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
        },
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.data = response.data.response.data
            this.colHeaders = response.data.response.columnHeaders
            this.isLoading = false
            this.initHoT()
          }
        })
        .catch(error => {
          this.printErrorModal(error)
          this.isLoading = false
        });
    },
    printErrorModal(error) {
      this.$swal({
        title: 'Error!',
        text: error,
        icon: 'error',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      })
    },
    integerValidator(value, callback) {
      if (value === 1 || value === 0) {
        callback(true);
      } else {
        callback(false);
      }
    },
    checkIfPresented() {
      const URL = '/nomina/is_presented'
      const config = {
        method: 'get', url: URL, params: {
          user_id: this.getUserID(),
          app_user_id: this.getUserID(),
        },
      }
      axiosIns(config)
        .then(response => {
          if (response && response.status === 200) {
            this.isPresented = response.data.response
          }
        })
        .catch(error => {
          this.printErrorModal(error)
        });
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
